var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wtw-container outfit-type-container clearfix" },
    _vm._l(_vm.options, function(option) {
      return _c(
        "div",
        {
          staticClass: "outfit-type-option",
          class: {
            active:
              _vm.optionActive(option.product_option_value_id) || _vm.allActive
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.toggleOption(option.product_option_value_id)
            }
          }
        },
        [
          _c("div", { staticClass: "image-wrapper" }, [
            _c("img", { attrs: { src: option.product_option_value_image_url } })
          ]),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.optionActive(option.product_option_value_id) ||
                  _vm.allActive,
                expression:
                  "optionActive(option.product_option_value_id) || allActive"
              }
            ],
            staticClass: "outfit-check",
            attrs: { src: _vm.imageUrl("Check-2-white.svg") }
          }),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "option",
              class: {
                active: _vm.optionActive(option.product_option_value_id)
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(option.product_option_value_title) +
                  "\n        "
              )
            ]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36306af8", { render: render, staticRenderFns: staticRenderFns })
  }
}